<template>
  <section class="selection-section">
    <!-- Language Selection moved to top-right corner -->
    <div class="header-container">
      <h2>Daten auswählen</h2>
      <div class="language-selection">
        <select :value="currentLanguage" @change="onLanguageChange">
          <option v-for="(language, index) in availableLanguages" :key="index" :value="language">
            {{ language }}
          </option>
        </select>
      </div>
    </div>



    <!-- Main selection container -->
    <div class="main-selection-container">
      <!-- User Selection (for admins only) -->
      <div v-if="isAdmin" class="selection-block">
        <label>Benutzer auswählen:</label>
        <div class="button-group">
          <button v-for="user in filteredUsers" :key="user.id" @click="selectUser(user)"
            :class="{ selected: selectedUser && selectedUser.id === user.id }">
            {{ user.username }}
          </button>
        </div>
      </div>

      <!-- Class Selection -->
      <div class="selection-block">
        <label>Klasse auswählen:</label>
        <div class="button-group">
          <button v-for="classItem in classes" :key="classItem.id" @click="selectClass(classItem)"
            :class="{ selected: selectedClass && selectedClass.id === classItem.id }">
            {{ classItem.name }}
          </button>
        </div>
      </div>

      <!-- Assessment Selection -->
      <div v-if="selectedClass" class="selection-block">
        <label>Umfrage auswählen:</label>
        <div class="button-group">
          <button v-for="assessment in filteredAssessments" :key="assessment.assessment_id"
            @click="selectAssessment(assessment)"
            :class="{ selected: selectedAssessment && selectedAssessment.assessment_id === assessment.assessment_id }">
            {{ formatAssessmentOption(assessment) }}
          </button>
        </div>
      </div>

      <!-- Student Selection -->
<!-- Student Selection -->
<div v-if="selectedAssessment && students.length > 0" class="selection-block">
  <label>Schüler:in auswählen:</label>
  <div class="button-group">
    <button v-for="student in students" :key="student.id" @click="selectStudent(student)"
      :class="{ selected: selectedStudent && selectedStudent.id === student.id }">
      {{ showStudentNames ? student.name : student.id }}
    </button>
  </div>
</div>


    </div>
  </section>
</template>

<script>
export default {
  props: {
    isAdmin: Boolean,
    filteredUsers: Array,
    classes: Array,
    filteredAssessments: Array,
    students: Array,
    selectedUser: Object,
    selectedClass: Object,
    selectedAssessment: Object,
    selectedStudent: Object,
    availableLanguages: Array,
    selectedLanguage: String,
    showStudentNames: Boolean
  },
  data() {
    return {
      currentLanguage: this.selectedLanguage
    };
  },
  methods: {
    selectUser(user) {
      this.$emit('select-user', user);
    },
    selectClass(classItem) {
      this.$emit('select-class', classItem);
    },
    selectAssessment(assessment) {
      this.$emit('select-assessment', assessment);
    },
    selectStudent(student) {
      // Check if a student was already selected
      const isUserInitiated = !this.selectedStudent;
      this.$emit('select-student', student, isUserInitiated);
    },
    onLanguageChange(event) {
      const language = event.target.value;
      this.currentLanguage = language;
      this.$emit('select-language', language);
    },
    formatAssessmentOption(assessment) {
      const id = assessment.assessment_id;

      try {
        // Swiss date format: DD.MM.YYYY
        const startDate = new Date(assessment.start_date).toLocaleDateString('de-CH', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        const endDate = new Date(assessment.end_date).toLocaleDateString('de-CH', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        // return `${id} - ${startDate} - ${endDate}`; // Commented out since Sergej wants only start date
        return `${id} - ${startDate}`;
      } catch (error) {
        console.error('Error formatting assessment dates:', error);
        return `${id} - Ungültige Daten`;
      }
    }
  },
  watch: {
    selectedLanguage(newValue) {
      this.currentLanguage = newValue;
    }
  }
};
</script>


<style scoped>
.selection-section {
  background-color: #f8f9fa;
  border: 0.5px solid #42b983;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 12px;
}

.header-container h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.3em;
  font-weight: 600;
}

.main-selection-container {
  margin: 0;
}

.selection-block {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px dashed #e9ecef;
}

.selection-block:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.selection-block label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #495057;
  font-size: 1em;
}

/* Language Selection Styles */
.language-selection {
  min-width: 120px;
}

.language-selection select {
  width: 100%;
  appearance: none;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #495057;
  cursor: pointer;
  font-size: 14px;
  padding: 6px 28px 6px 10px;
  transition: all 0.2s ease-in-out;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23495057' d='M3.8 4.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.4.4 1 .4 1.4 0l3-3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L6 6.6 3.8 4.4z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.language-selection select:hover {
  border-color: #adb5bd;
}

.language-selection select:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
  outline: 0;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
}

.button-group button {
  padding: 8px 14px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.button-group button:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.button-group button:active {
  background-color: #e9ecef;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
}

.button-group button.selected,
.button-group button.active {
  background-color: #4caf50;
  color: white;
  border-color: #4caf50;
  box-shadow: 0 1px 3px rgba(76, 175, 80, 0.3);
}

.button-group button.selected:hover,
.button-group button.active:hover {
  background-color: #43a047;
}
</style>
